// @flow

import * as React from 'react'
import styled from 'styled-components'
import { Colors } from './../Colors'
import { BaseButton, IconInTheButton, type BaseButtonProps } from './BaseButton'

const StyledFilledButton = styled(BaseButton)`
  color: ${Colors.black100};
  border-color: transparent;
  background-color: ${Colors.white100};

  &:hover {
    color: ${Colors.white100};
    border-color: transparent;
    background-color: ${Colors.black75};
  }

  &:disabled {
    color: ${Colors.black35};
    border-color: transparent;
    background-color: ${Colors.white10};
  }

  & ${IconInTheButton} path {
    fill: ${Colors.black100};
    transition: fill 0.25s ease-in-out;
  }

  &:hover ${IconInTheButton} path {
    fill: ${Colors.white100};
  }
`

export const FilledButton = ({
  children,
  ...otherProps
}: {
  ...BaseButtonProps,
}): React.Node => (
  <StyledFilledButton {...otherProps}>{children}</StyledFilledButton>
)
